import { BenefitStatus } from '@zorro/clients';
import { Pill } from '@zorro/design-system/v2/Pill';

import { getBenefitStatusBadgeView } from './BenefitStatusBadgeUtils';

type Props = {
  status?: BenefitStatus | null;
};

export const BenefitStatusBadge = ({ status }: Props) => {
  const view = getBenefitStatusBadgeView(status);

  if (!view) {
    return <>-</>;
  }

  return (
    <Pill variant="tag" color={view.color} leftSection={view.icon}>
      {view.label}
    </Pill>
  );
};
